import { useState } from 'react'
import { Box } from '@mui/system'
import { makeStyles } from '@material-ui/core/styles'
import MultiStageSlider from './components/MultiStageSlider'
import MultiStageSliderLabels from './components/MultiStageSliderLabels'

/**
 * @param {object} className
 * @param {object} marks Array of marks for the slider. Each mark contains a label and a value
 *  => Note: The label will appear on the value part of the slider (50 => 50% = midlle of the slider)
 * @param {function} onChange function will return and receive the selected value based on entry marks
 * @param {boolean} disabled
 * @returns {React Component}
 */

/**
 * Sample Code
 *
 * const marks = [
 *  {value: 0, label: "First Label"},{value: 50, label: "Mid Label"},{value: 100,label: "Last Label"}
 * ]
 *
 * <MultiStageSwitch
 *    className={className}
 *    marks={[{value: 0, label: "Label Start"},{value: 50, label: "SSO User"},{value: 100,label: "Guest User"}]}
 *    onChange={(selectedValue) => console.log(selectedValue)}
 *    disabled={false}
 * />
 *
 */
const MultiStageSwitch = ({
  className,
  marks,
  onChange,
  disabled,
  initialState
}) => {
  const [selectedIem, setSelectedItem] = useState(initialState)
  const classes = useStyles()

  return (
    <Box className={`${classes.root} ${className}`}>
      <MultiStageSliderLabels
        marks={marks}
        selectedIem={selectedIem}
        disabled={disabled}
      />
      <MultiStageSlider
        marks={marks}
        onChange={onChange}
        selectedIem={selectedIem}
        setSelectedItem={setSelectedItem}
        disabled={disabled}
      />
    </Box>
  )
}

export default MultiStageSwitch

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
  }
}))

